<template>
    <div class="toggle-tab" role="button" tabindex="0" :aria-expanded="showList" :aria-label="tabCaption" @click="toggle" @keydown.enter="toggle" @keydown.space.prevent="toggle" @pointerenter="isHovered= true" @pointerleave="isHovered=false" @touchstart="isHovered= false">
        <rotate-chevron :direction="chevronDirection" :class="{'bouncy-arrow': isHovered}" aria-hidden="true"/>
        <img src="/images/icon-flyer.svg" class="flyer-book" width="22px" height="22px"  alt=""/>
        <span class="caption" data-tour-item="flyer-selector">{{ tabCaption }}</span>
        <PoweredByTC v-if="isPoweredByTC" />
    </div>

</template>
<script>
import featureMixin from "@/mixins/featureMixin";
import RotateChevron from "@/components/buttons/RotateChevron.vue";
import PoweredByTC from "@/features/flyer-selector/inline/PoweredByTC.vue"
import Lytics from "@/classes/Lytics";
import { mapActions, mapGetters } from "vuex";
import {appDict} from "@/features/FeatureHelper";

export default {
name: "InlineFilterSelector",
components: { RotateChevron, PoweredByTC},
mixins:[featureMixin],
data(){
return {
    featurePath: 'filterSortSelector',
    isHovered: false,
}
},
computed:{
     ...mapGetters("inlineDrawers", ["isFilterOpen","isFilterSortWindowOpen"]),
     ...mapGetters("screen", ["displayMode"]),
        isPoweredByTC() {
        return this.config?.poweredByTC
        },
        chevronDirection(){
            const cd = {
                'left': this.showList? 'left': 'right',
                'right': this.showList? 'right': 'left',
                'top': this.showList? 'up': 'down',
                'bottom': this.showList? 'down': 'up'
            }
            return cd[this.config.position];
        },
        tabCaption(){
            return this.showList? this.content?.filterSortSelector?.hideFilter: this.content?.filterSortSelector?.viewFilter
        },
        showList(){
            console.log("showList",this.isFilterSortWindowOpen)
            return !!this._config.isVisible || this.isFilterSortWindowOpen;
        },
        drawerPosition() {
                return this.config.position;
                },
        isMobileOrTablet() {
            return this.displayMode === 'mobile' || this.displayMode === 'tablet';
        },
        },
methods:{
    ...mapActions("inlineDrawers", ["openFilter", "openFlyer",'setFilterSortWindowOpen']),
    ...mapActions("drawer", ["openSingleInDrawer"]),
    ...mapActions('filters', ['clearFilters']),

    toggle() {

         if(this.isFilterSortWindowOpen) {
            this.setFilterSortWindowOpen(!this.isFilterSortWindowOpen);
            // On mobile/tablet, closing the filter/sort window via this toggle is a
            // cancel action — keep the currently displayed search results intact.
           
            if (!this.isMobileOrTablet) this.clearFilters();
            return;
          }

            const drawer = this.drawerPosition;
          
            if (this.isFilterOpen) {
                // Replace FILTER with FLYER
                  this.openSingleInDrawer({id: 'flyerSelector', component: appDict.inlineFlyerSelector, drawer: drawer,attrs: { autofocus: true }, })
                   this.openFlyer();
                   Lytics.TriggerDrawerToggle(true);
            }
            else {
                    // Replace FLYER with FILTER
                    this.openSingleInDrawer({id: this.featurePath, component: appDict.inlineFilterSelector, drawer: drawer, attrs: {autofocus: true}, });
                    this.openFilter();
                    Lytics.TriggerDrawerToggle(true);
            }
    },

}
}
</script>

<style lang="scss">
.inline-filter-selector {
--drawer-open-width: 10em;
display: flex;
color: #fff;
.toggle-tab {
    position: relative;
    background-color: #333333;
    display: flex;
    writing-mode: vertical-rl;
    //column-gap: 0.5em;
    cursor: pointer;
    align-items: center;
    .caption {
        rotate: 180deg;
        font-size: 0.8em;
    }
    .rotate-chevron {
        width: 0.6em;
    }
    
}


&.left{
    .toggle-tab {
        padding: 1em 0;
        width: 38px;
        border-radius: 0 4px 4px 0;
        > * {
        margin-bottom: 0.5em;
    }
    }
}
&.top{
    flex-direction: column;
    .toggle-tab {
        writing-mode: initial;
        justify-content: center;
        padding: 0.5em;
        border-radius: 0 0 4px 4px;
        .caption {
            rotate: 0deg;
        }
        > * {
        margin-right: 0.5em;
       }  
    }
}
}

</style>
